<template>
  <div id="crm_user_company_clothe">
    <el-form
      ref="form"
      :model="company_clothe_details"
      label-width="120px"
    >
      <el-form-item
        label="overwrite"
      >
        <el-checkbox
          v-model="company_clothe_details.overwrite"
          size="small"
        />
      </el-form-item>
      <p>Description for PDF</p>
      <jodit-editor
        v-model="company_clothe_details.description"
        :buttons="buttons"
      />
      <br>
      <el-button
        type="primary"
        size="small"
        style="float:right;"
        @click="save_details"
      >
        Save
      </el-button>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'CrmUserCompanyClothe',
  props: {
    crm_user_id: {
      type: [String,Number],
      required: true
    }
  },
  data() {
    return {
      company_clothe_details: {
        description: '',
        overwrite: false
      },
      buttons: [
        'source',
        'link',
        '|',
        'bold',
        'underline',
        'strikethrough',
        'italic',
        'paragraph',
        'cut',
        'copy',
        'paste',
      ]
    };
  },
  watch: {
    crm_user_id(){
      this.get_company_clothe_details();
    }
  },
  mounted() {
    this.get_company_clothe_details();
  },
  created() {
  },
  methods: {
    get_company_clothe_details(){
      this.$http.get('/company_clothe_details/'+ this.crm_user_id).then(
        (response) => {
          this.company_clothe_details = response.data;
        });
    },
    save_details(){
      this.$http.post(`/create_or_update_company_clothe/${this.crm_user_id}`, this.company_clothe_details).then(() => {
        this.$message({
          message: 'Company Clothe details updated.',
          type: 'success',
        });
        this.get_company_clothe_details();
      }, () => {
        this.$message({
          message: 'Error',
          type: 'error',
        });
        this.get_company_clothe_details();
      });
    },
  }
};
</script>
<style scoped>
#crm_user_company_clothe {
  max-width: 800px;
}
</style>
